import { Link } from "react-router-dom";
import "./quickAccess.scss";

function QuickAccessItem({ to, label, Icon, ariaLabel }) {
  return (
    <Link
      to={to}
      className="QuickAccessItem"
      aria-label={ariaLabel || label}
    >
      <span className="QuickAccessItem__icon" aria-hidden="true">
        <Icon />
      </span>
      <span className="QuickAccessItem__title">{label}</span>
    </Link>
  );
}

export default QuickAccessItem;
